import Axios from '@/services/axios'
import msg from '@/common/msg'
import * as code from '@/common/code'
export default {
  getData (url, params) {
    return new Promise((resolve, reject) => {
      Axios.get(
        url,
        params,
        response => {
          if (!response || !response.data || !response.data.records || !response.data.recordList) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            if (response.data.header.resultCode === code.amazonInfoNotFound) {
              reject(response.data.header.resultCode)
            } else if (response.data.header.resultCode === code.amazonThrottleError) {
              reject(response.data.header.resultCode)
            }
            reject(response.data.header.message)
          }
          resolve({
            ...response.data.records,
            ...response.data.recordList
          })
        },
        error => {
          reject(error)
        }
      )
    })
  },

  postDataByExtraUrl (url, params) {
    return new Promise((resolve, reject) => {
      Axios.post(
        url,
        params,
        response => {
          if (!response || !response.data || !response.data.records || !response.data.recordList) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            if (response.data.header.resultCode === code.amazonInfoNotFound) {
              reject(response.data.header.resultCode)
            }
            reject(response.data.header.message)
          }
          resolve({
            ...response.data.records,
            ...response.data.recordList
          })
        },
        error => {
          reject(error)
        }
      )
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/paginationservice.js